import React, { Component } from 'react';
import { connect } from 'shalala';
import { Col, Row } from 'react-bootstrap';

import { useStore } from '../../../store';
import Loading from '../../../facturotopia/loading/Loading';
import PageHeader from '../../../support/page-header/PageHeader';
import FacturasGlobalesTicketGeneralInfo from './components/FacturasGlobalesTicketGeneralInfo';
import ComprobanteDownloadActions from '../../../app/comprobantes/info/components/ComprobanteDownloadActions';

class FacturasGlobalesTicketInfo extends Component {
  state = {};

  constructor(props) {
    super(props);

    const { data = {} } = props.location.state;
    const { id } = this.props.match.params;

    if (data.id) {
      props.info.setInfo(data);
    } else {
      props.info.reset();
      props.info.detail(id);
    }
  }

  componentWillUnmount() {
    this.setState = () => {};
  }

  render() {
    const { data = {}, busy } = this.props;

    if (!!busy) {
      return <Loading className="text-info" />;
    }

    return (
      <>
        <PageHeader
          to="/modulos/fpg/tickets"
          text="Tickets"
        />

        <Row>
          <Col className="text-right">
            <div className="d-inline-flex ">
              {!!data.cfdi_uuid && [1, 'success', -1, 'cancelled'].indexOf(data.status) > -1 && (
                <div>
                  <ComprobanteDownloadActions data={{ uuid: data.cfdi_uuid }} />
                </div>
              )}
            </div>
          </Col>
        </Row>

        <FacturasGlobalesTicketGeneralInfo data={data} />
      </>
    );
  }
}

const mapActions = (actions) => {
  return {
    info: actions.modulo.fpg.info,
  };
};

const mapState = (store) => {
  return store.modulo.fpg.info;
};

export default connect(useStore, mapState, mapActions)(FacturasGlobalesTicketInfo);
